import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { API_BASE_URL } from '../utils/config';
import './AdminDashboard.css';

function AdminDashboard() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [date, setDate] = useState('');
  const [settings, setSettings] = useState({
    slotDuration: 60,
    workingHours: {
      start: '09:30',
      end: '17:30'
    },
    breakTimes: [
      {
        start: '',
        end: ''
      }
    ],
    disabledSlots: []
  });
  
  // 全局设置状态
  const [isGlobalSettings, setIsGlobalSettings] = useState(false);
  const [globalSettings, setGlobalSettings] = useState({
    slotDuration: 60,
    workingHours: {
      start: '09:30',
      end: '17:30'
    },
    breakTimes: [
      {
        start: '',
        end: ''
      }
    ],
    disabledSlots: [],
    weekDays: {
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: false,
      sunday: false
    }
  });
  
  const [appointments, setAppointments] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // 检查是否已经登录
    const adminToken = localStorage.getItem('adminToken');
    if (!adminToken) {
      navigate('/admin-login');
    } else {
      setIsAuthenticated(true);
    }
  }, [navigate]);

  // 处理登出
  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin-login');
  };

  // 切换单日/全局设置模式
  const toggleSettingsMode = () => {
    setIsGlobalSettings(!isGlobalSettings);
    setMessage('');
    setError('');
  };

  // 处理全局设置的星期选择
  const handleWeekDayChange = (day) => {
    setGlobalSettings({
      ...globalSettings,
      weekDays: {
        ...globalSettings.weekDays,
        [day]: !globalSettings.weekDays[day]
      }
    });
  };

  // 处理全局设置中的工作时间更改
  const handleGlobalWorkingHoursChange = (field, value) => {
    setGlobalSettings({
      ...globalSettings,
      workingHours: {
        ...globalSettings.workingHours,
        [field]: value
      }
    });
  };

  // 处理全局设置中的时间段时长更改
  const handleGlobalSlotDurationChange = (value) => {
    setGlobalSettings({
      ...globalSettings,
      slotDuration: parseInt(value)
    });
  };

  // 添加或删除全局设置中的休息时间
  const handleGlobalBreakTimeChange = (index, field, value) => {
    const newBreakTimes = [...globalSettings.breakTimes];
    newBreakTimes[index] = {
      ...newBreakTimes[index],
      [field]: value
    };
    setGlobalSettings({
      ...globalSettings,
      breakTimes: newBreakTimes
    });
  };

  const addGlobalBreakTime = () => {
    setGlobalSettings({
      ...globalSettings,
      breakTimes: [...globalSettings.breakTimes, { start: '', end: '' }]
    });
  };

  const removeGlobalBreakTime = (index) => {
    const newBreakTimes = globalSettings.breakTimes.filter((_, i) => i !== index);
    setGlobalSettings({
      ...globalSettings,
      breakTimes: newBreakTimes
    });
  };

  // 添加或删除单日休息时间
  const handleBreakTimeChange = (index, field, value) => {
    const newBreakTimes = [...settings.breakTimes];
    newBreakTimes[index] = {
      ...newBreakTimes[index],
      [field]: value
    };
    setSettings({
      ...settings,
      breakTimes: newBreakTimes
    });
  };

  const addBreakTime = () => {
    setSettings({
      ...settings,
      breakTimes: [...settings.breakTimes, { start: '', end: '' }]
    });
  };

  const removeBreakTime = (index) => {
    const newBreakTimes = settings.breakTimes.filter((_, i) => i !== index);
    setSettings({
      ...settings,
      breakTimes: newBreakTimes
    });
  };

  // 保存全局设置
  const saveGlobalSettings = async () => {
    try {
      const adminToken = localStorage.getItem('adminToken');
      
      console.log('Saving global settings');
      console.log('Global settings:', globalSettings);

      const response = await fetch(`${API_BASE_URL}/api/admin/global-availability`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${adminToken}`
        },
        body: JSON.stringify({
          settings: {
            ...globalSettings,
            breakTimes: globalSettings.breakTimes || [],
            disabledSlots: globalSettings.disabledSlots || []
          }
        })
      });

      const data = await response.json();
      console.log('Save global response:', data);

      if (data.success) {
        setMessage('全局设置已保存');
        setError('');
      } else {
        setError(data.error || '保存失败');
        setMessage('');
      }
    } catch (err) {
      console.error('Save error:', err);
      setError('保存全局设置时出错');
      setMessage('');
    }
  };

  // 保存单日设置
  const saveSettings = async () => {
    try {
      const adminToken = localStorage.getItem('adminToken');
      if (!date) {
        setError('请选择日期');
        return;
      }

      console.log('Saving settings for date:', date);
      console.log('Settings:', settings);

      const response = await fetch(`${API_BASE_URL}/api/admin/availability`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${adminToken}`
        },
        body: JSON.stringify({
          date,
          settings: {
            ...settings,
            breakTimes: settings.breakTimes || [],
            disabledSlots: settings.disabledSlots || []
          }
        })
      });

      const data = await response.json();
      console.log('Save response:', data);

      if (data.success) {
        setMessage('设置已保存');
        setError('');
      } else {
        setError(data.error || '保存失败');
        setMessage('');
      }
    } catch (err) {
      console.error('Save error:', err);
      setError('保存设置时出错');
      setMessage('');
    }
  };

  // 加载预约
  const loadAppointments = async () => {
    if (!date) {
      setError('请选择日期');
      return;
    }

    try {
      const adminToken = localStorage.getItem('adminToken');
      const response = await fetch(`${API_BASE_URL}/api/admin/appointments?date=${date}`, {
        headers: {
          'Authorization': `Bearer ${adminToken}`
        }
      });

      const data = await response.json();
      if (Array.isArray(data)) {
        setAppointments(data);
        setError('');
      } else {
        setError('加载预约失败');
        setAppointments([]);
      }
    } catch (err) {
      setError('加载预约时出错');
      setAppointments([]);
    }
  };

  if (!isAuthenticated) {
    return <div>正在验证身份...</div>;
  }

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h2>管理员控制面板</h2>
        <div className="header-actions">
          <Link to="/" className="home-link">返回首页</Link>
          <button onClick={handleLogout} className="logout-btn">登出</button>
        </div>
      </div>

      <div className="settings-mode-toggle">
        <button 
          className={`mode-btn ${!isGlobalSettings ? 'active' : ''}`}
          onClick={() => setIsGlobalSettings(false)}
        >
          单日设置
        </button>
        <button 
          className={`mode-btn ${isGlobalSettings ? 'active' : ''}`}
          onClick={() => setIsGlobalSettings(true)}
        >
          全局设置
        </button>
      </div>

      <div className="dashboard-content">
        <div className="settings-section">
          <h3>{isGlobalSettings ? '全局时间设置' : '单日时间设置'}</h3>
          
          {!isGlobalSettings && (
            <div className="form-group">
              <label>选择日期：</label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
              <button onClick={loadAppointments} className="load-btn">加载预约</button>
            </div>
          )}

          {isGlobalSettings && (
            <div className="form-group">
              <label>应用于星期：</label>
              <div className="weekdays-selector">
                <label className={globalSettings.weekDays.monday ? 'selected' : ''}>
                  <input 
                    type="checkbox" 
                    checked={globalSettings.weekDays.monday} 
                    onChange={() => handleWeekDayChange('monday')} 
                  />
                  一
                </label>
                <label className={globalSettings.weekDays.tuesday ? 'selected' : ''}>
                  <input 
                    type="checkbox" 
                    checked={globalSettings.weekDays.tuesday} 
                    onChange={() => handleWeekDayChange('tuesday')} 
                  />
                  二
                </label>
                <label className={globalSettings.weekDays.wednesday ? 'selected' : ''}>
                  <input 
                    type="checkbox" 
                    checked={globalSettings.weekDays.wednesday} 
                    onChange={() => handleWeekDayChange('wednesday')} 
                  />
                  三
                </label>
                <label className={globalSettings.weekDays.thursday ? 'selected' : ''}>
                  <input 
                    type="checkbox" 
                    checked={globalSettings.weekDays.thursday} 
                    onChange={() => handleWeekDayChange('thursday')} 
                  />
                  四
                </label>
                <label className={globalSettings.weekDays.friday ? 'selected' : ''}>
                  <input 
                    type="checkbox" 
                    checked={globalSettings.weekDays.friday} 
                    onChange={() => handleWeekDayChange('friday')} 
                  />
                  五
                </label>
                <label className={globalSettings.weekDays.saturday ? 'selected' : ''}>
                  <input 
                    type="checkbox" 
                    checked={globalSettings.weekDays.saturday} 
                    onChange={() => handleWeekDayChange('saturday')} 
                  />
                  六
                </label>
                <label className={globalSettings.weekDays.sunday ? 'selected' : ''}>
                  <input 
                    type="checkbox" 
                    checked={globalSettings.weekDays.sunday} 
                    onChange={() => handleWeekDayChange('sunday')} 
                  />
                  日
                </label>
              </div>
            </div>
          )}

          <div className="form-group">
            <label>时间段时长（分钟）：</label>
            <select
              value={isGlobalSettings ? globalSettings.slotDuration : settings.slotDuration}
              onChange={(e) => isGlobalSettings 
                ? handleGlobalSlotDurationChange(e.target.value)
                : setSettings({
                    ...settings,
                    slotDuration: parseInt(e.target.value)
                  })
              }
            >
              <option value="15">15分钟</option>
              <option value="30">30分钟</option>
              <option value="45">45分钟</option>
              <option value="60">60分钟</option>
            </select>
          </div>

          <div className="form-group">
            <label>工作时间：</label>
            <div className="time-range">
              <input
                type="time"
                value={isGlobalSettings ? globalSettings.workingHours.start : settings.workingHours.start}
                onChange={(e) => isGlobalSettings
                  ? handleGlobalWorkingHoursChange('start', e.target.value)
                  : setSettings({
                      ...settings,
                      workingHours: {
                        ...settings.workingHours,
                        start: e.target.value
                      }
                    })
                }
              />
              <span>至</span>
              <input
                type="time"
                value={isGlobalSettings ? globalSettings.workingHours.end : settings.workingHours.end}
                onChange={(e) => isGlobalSettings
                  ? handleGlobalWorkingHoursChange('end', e.target.value)
                  : setSettings({
                      ...settings,
                      workingHours: {
                        ...settings.workingHours,
                        end: e.target.value
                      }
                    })
                }
              />
            </div>
          </div>

          <div className="form-group">
            <label>休息时间：</label>
            <button 
              type="button" 
              onClick={isGlobalSettings ? addGlobalBreakTime : addBreakTime} 
              className="add-break-btn"
            >
              添加休息时间
            </button>
            
            {(isGlobalSettings ? globalSettings.breakTimes : settings.breakTimes).map((breakTime, index) => (
              <div key={index} className="break-time-item">
                <input
                  type="time"
                  value={breakTime.start}
                  onChange={(e) => isGlobalSettings
                    ? handleGlobalBreakTimeChange(index, 'start', e.target.value)
                    : handleBreakTimeChange(index, 'start', e.target.value)
                  }
                />
                <span>至</span>
                <input
                  type="time"
                  value={breakTime.end}
                  onChange={(e) => isGlobalSettings
                    ? handleGlobalBreakTimeChange(index, 'end', e.target.value)
                    : handleBreakTimeChange(index, 'end', e.target.value)
                  }
                />
                <button
                  type="button"
                  onClick={() => isGlobalSettings
                    ? removeGlobalBreakTime(index)
                    : removeBreakTime(index)
                  }
                  className="remove-break-btn"
                >
                  删除
                </button>
              </div>
            ))}
          </div>

          <button 
            onClick={isGlobalSettings ? saveGlobalSettings : saveSettings} 
            className="save-btn"
          >
            {isGlobalSettings ? '保存全局设置' : '保存设置'}
          </button>

          {message && <div className="success-message">{message}</div>}
          {error && <div className="error-message">{error}</div>}
        </div>

        {!isGlobalSettings && (
          <div className="appointments-section">
            <h3>预约列表</h3>
            {appointments.length > 0 ? (
              <table className="appointments-table">
                <thead>
                  <tr>
                    <th>预约号</th>
                    <th>时间</th>
                    <th>姓名</th>
                    <th>电话</th>
                    <th style={{minWidth: '200px'}}>当前现状</th>
                    <th style={{minWidth: '200px'}}>需要解决的问题</th>
                  </tr>
                </thead>
                <tbody>
                  {appointments.map((appointment) => (
                    <tr key={appointment.id}>
                      <td className="id-cell">{appointment.id}</td>
                      <td className="time-cell">{`${appointment.startTime} - ${appointment.endTime}`}</td>
                      <td>{appointment.name}</td>
                      <td>{appointment.phone}</td>
                      <td className="description-cell">
                        {appointment.currentSituation || '无'}
                      </td>
                      <td className="description-cell">
                        {appointment.problemToSolve || '无'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>暂无预约数据</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;